import { ExternalNotesComponent } from "./external-notes.component";
export const ExternalNotesModule = angular
    .module('externalNotes', [])
    .component(ExternalNotesComponent.selector, ExternalNotesComponent.component)
    .value('EventEmitter', payload => ({ $event: payload }))
    .name;
//# sourceMappingURL=external-notes.module.js.map